// extracted by mini-css-extract-plugin
module.exports = {"iconsWrapper":"CalendarEvent_iconsWrapper__2o7bg","gfeWrapper":"CalendarEvent_gfeWrapper__3Seyj"};